import unifyBridge from '@didi/unify-bridge'
import { env, version } from '@didi/utils'
import bridge from '@didi/driver-biz-sdk/lib/bridge'
import { params } from '@didi/driver-biz-sdk'

// compare('5.0.2', '>', '4.8.0') // true
export const canUse = (() => {
  if (!env.isDriver) return false
  if (env.isAndroid) return version.compare(bridge.version(), '>=', '8.1.6')
  if (env.isIOS) return version.compare(bridge.version(), '>=', '8.2.10')
  return false
})()

export function showNavBar(): Promise<string> {
  if (!canUse) return Promise.reject(new Error('no in version'))
  if (params.urlParams.hideNativeBar === 'false') return Promise.reject(new Error('with url params "hideNativeBar" false'))

  return unifyBridge.showNavigationBar({})
}

export function hideNavBar(): Promise<string> {
  if (!canUse) return Promise.reject(new Error('no in version'))
  if (params.urlParams.hideNativeBar === 'false') return Promise.reject(new Error('url params "hideNativeBar" false'))

  return unifyBridge.hideNavigationBar({})
}
